import React from 'react';
import { Info } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';
import { Colors } from '../../styles/Colors';

export interface InfoBannerProps {
    text: string;
    className?: string;
}

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        padding: '14px 20px 8px 20px',
        marginTop: 6,
        marginBottom: 19,
        userSelect: 'none',
        background: 'rgba(221, 225, 231, 0.5)',
        borderRadius: 4,
        width: 'fit-content'
    },
    label: {
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '20px',
        verticalAlign: 'middle',
        color: Colors.Text3,
        marginTop: 4,
    },
    icon: {
        color: Colors.Text3 + ` !important`,
        '& svg': {
            '& path': {
                fill: Colors.Text3 + ` !important`,
                fillOpacity: 1,
            },
        },
        marginRight: 12,
    },
}));

const InfoBanner: React.FC<InfoBannerProps> = ({ text, className }) => {
    const classes = useStyles();

    return (
        <div className={`${classes.container} ${className ?? ''}`}>
            <div className={classes.icon}><Info /></div>
            <div className={classes.label}>{text}</div>
        </div>
    );
};

export default InfoBanner;